import { createContext } from 'react';


const PermissionContext = createContext<{newPermission:boolean,setNewPermission:Function}>({
 newPermission:false,
setNewPermission:()=>{}
});

export default PermissionContext;
